<template>
<div class="exam-question">
  <div class="exam-question_cnt">
     <div class="question-body body-img" v-if="question.contentPayload.questionStem.image">
        <img :src="question.contentPayload.questionStem.image" />
      </div>
      <div class="question-body" v-else v-html="question.contentPayload.questionStem.text"></div>

      <div class="question-audio" v-if="question.contentPayload.questionStem.audio">
        <audio-player :voiceUrl="question.contentPayload.questionStem.audio"></audio-player>
      </div>
  </div>

  <div v-if="question.questionType === 'TEXT_CHOICE_QUESTION'" class="question-options" :class="`show-in-${optionShowType}`">
    <div :class="['question-option',{
      'selected': selectedOptions.includes(item.id),
    }]" v-for="(item,index) in question.contentPayload.options" :key="index" @click="handleOptionClick(item)">
      <span class="option">{{item.id}}<span v-if="question.contentPayload.optionType !== 'EMPTY'">.</span></span>
      <template v-if="question.contentPayload.optionType !== 'EMPTY'">
        <div v-if="question.contentPayload.optionType === 'TEXT'" class="option-content"><p>{{item.text}}</p></div>
        <template v-else-if="question.contentPayload.optionType === 'PICTURE'" >
          <div class="option-content">
            <img :src="item.image">
          </div>
        </template>
        <p v-else v-html="item.text" class="option-content"></p>
      </template>
    </div>
  </div>

  <div v-else class="question-upload">
    <div class="question-upload_title">
      <span class="title">请拍照上传你的答案：</span>
      <span class="example-tip" @click="handleExampleShow">拍照示意图</span>
    </div>
    <div class="question-upload_list">
      <ImageUploader
        v-for="item in 5"
        :key="item"
        v-model="imgList[item-1]"
        @input="handleImageUpload"
      />
    </div>
  </div>
  <base-modal
    v-if="sampleDialogVisible"
    class="sampleModal"
    :hideFooter="true"
    @close="sampleDialogVisible = false"
  >
    <div class="sampleModal_title" slot="title" v-if="question.questionType === 'PICTURE_BLANK_FILLING'"><span class="ic-phone"></span>请正对答案进行拍摄</div>
    <div class="sampleModal_title" slot="title" v-else>请正对答案进行拍摄，拍摄完整解题过程</div>
    <div class="sampleModal_cnt" slot="content">
      <img class="sampleModal_cnt-img" src="https://pandapub.nosdn.127.net/tmp1754045660_t4ftc54wb3yqukq1tfqbya%3D%3D_2_1754042060_23.png" v-if="question.questionType === 'PICTURE_BLANK_FILLING'">
      <img class="sampleModal_cnt-img" src="https://pandapub.nosdn.127.net/tmp1754045659_nvof6kiemu9slrrfiy3yog%3D%3D_2_1754042059_3.png" v-else>
      <div class="sampleModal_cnt-tip">*请确保字迹清晰可见，避免涂改和黑点<template v-if="question.questionType === 'PICTURE_PROOF'">，可上传多张</template></div>
    </div>
  </base-modal>
</div>
</template>

<script>
import { arraysHaveSameIds } from '@/common/js/util';
import AudioPlayer from '@/components/audioPlayer.vue';
import ImageUploader from './ImageUploader.vue';
import BaseModal from '@/components/baseModal.vue';

export default {
  name: 'ExamQuestion',
  components: {
    AudioPlayer,
    ImageUploader,
    BaseModal,
  },
  props: {
    question: {
      type: Object,
      default: null
    },
    userAnswer: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    optionShowType() {
      const longOption = this.question.contentPayload?.options?.find(i => i.text?.length > 10);
      if (longOption) return 'list';
      return 'line'
    },
    selectedOptions() {
      return (this.userAnswer?.submitOption || []).map(i => i.id);
    },
  },
  data(){
    return {
      imgList: this.userAnswer?.pics || [],
      sampleDialogVisible: false,
    };
  },
  methods: {
    // 选择题，前端判断是否正确
    checkSelectQuestion(userAnswer) {
      const correctOption = this.question.validatePayload.correctOption;
      if (userAnswer.length === 0) {
        return {
          validationStatus: 'NOTACTIVE',
          points: 0,
        }
      } else if (arraysHaveSameIds(correctOption, userAnswer.map(item => item.id))) {
        return {
          validationStatus: 'CORRECT',
          points: parseFloat(this.question.score) * 10,
        }
      }
      return {
        validationStatus: 'WRONG',
        points: -parseFloat(this.question.errorScore || 0) * 10,
      }

    },
    handleOptionClick(item) {
      let userAnswer = [];
      if (this.userAnswer.submitOption?.some(i => i.id === item.id)) { // 取消选中
        userAnswer = this.userAnswer.submitOption.filter(i => i.id !== item.id);
      } else if (this.question.questionType === 'TEXT_CHOICE_QUESTION') {
        userAnswer = [item];
      } else {
        userAnswer = [...this.userAnswer.submitOption, item];
      }
      this.$emit("submitQuestion", {
        submitPayload: {
          submitOption: userAnswer,
        },
        ...this.checkSelectQuestion(userAnswer)
      })
    },
    handleExampleShow() {
      this.sampleDialogVisible = true;
    },
    handleImageUpload(e) {
      this.$emit("submitQuestion", {
        submitPayload: {
          pics: this.imgList.filter(i => !!i),
        }
      })
    }
  }

}
</script>

<style lang="less" scoped>
  .exam-question {
    text-align: left;
    &_cnt {
      display: flex;
      padding: 20px 0 30px;
      .question-audio {
        width: 24px;
        margin-left: 10px;
      }
      .question-body {
        flex: 1;
        &.body-img {
          background: #F5F6F9;
          display: flex;
          justify-content: center;
          border-radius: 20px;
          overflow: hidden;
          img {
            min-height: 440px;
            max-height: 552px;
            height: 50vh;
            margin-top: -5.5vh;
            margin-bottom: -2vh;
          }
        }
      }
      .question-body{
        img {
          max-width: 100%
        };
      }
    }
    .question-options {
      display: flex;
      flex-direction: column;
      &.show-in-line {
        flex-direction: row;
        flex-wrap: wrap;
        column-gap: 18px;
        .question-option {
          min-width: 120px;
          // flex: 1 0 120px;
          justify-content: center;
          white-space: nowrap;
        }
      }
      &.show-in-list {
        .question-option {
          min-width: 460px;
        }
      }
      .question-option {
        display: flex;
        align-content: center;
        background: #F5F6F9;
        color: #1D2129;
        padding: 12px 40px;
        font-weight: 500;
        font-size: 16px;
        margin-bottom: 20px;
        border-radius: 8px;
        cursor: pointer;
        width: fit-content;
        box-sizing: border-box;
        &:hover {
          background: #dfc89e;
        }
        &.selected {
          background: #BD9F68;
        }
        &.disabled {
          background: #F7F8FA;
          color: #C9CDD4;
          cursor: no-drop;
        }
        .option-content {
          margin-left: 16px;
        }
      }
    }
    .question-upload {
      &_title {
        display: flex;
        align-items: flex-end;
        font-weight: 500;
        margin-bottom: 32px;
        .title {
          color: #1D2129;
          font-size: 18px;
        }
        .example-tip {
          color: #3491FA;
          font-size: 14px;
          margin-left: 8px;
          cursor: pointer;
        }
      }
      &_list {
        display: flex;
        gap: 20px;
      }
    }
  }
</style>

<style lang="less">
  .exam-question {
    .question-body {
      color: #1D2129;
      font-size: 18px;
      line-height: 1.5;
      font-weight: 500;
      p {
        margin-bottom: 16px;
        &:last-child {
          margin-bottom: 0;
        }
        img{
          max-width: 100%;
          display: inline;
        }
      }
      img{
        max-width: 100%;
      }
    }
    .question-option{
      .option-content{
        p {
          font-size: 16px;
          font-weight: 500;
          word-break: break-all;
          img{
            max-width: 100%;
          }
        }
        img{
          max-width: 100%;
          // max-height: 60px;
        }
      }
    }
  }
  .sampleModal.base-modal {
    .base-modal_cnt {
      width: 528px;
    }
    .sampleModal_title {
      display: flex;
      align-items: center;
      color: #1D2129;
      font-size: 24px;
      font-weight: 600;
      .ic-phone {
        width: 30px;
        height: 30px;
        background: url("@/common/images/student/ic_phone.png") center / contain no-repeat;
        margin-right: 7px;
      }
    }
    .sampleModal_cnt {
      display: flex;
      flex-direction: column;
      &-img {
        width: 464px;
        margin-bottom: 20px;
      }
      &-tip {
        font-size: 20px;
        color: #4E5969;
        white-space: nowrap;
        text-align: left;
      }
    }
  }
</style>